export const meta_paths = ['home', 'menu', 'gallery', 'contact', 'offers']